// extracted by mini-css-extract-plugin
module.exports = {"town":"town___-39CYEL3QLT9k42T0Pbec-O","town__container":"town__container___-7bz13bfeEthgUrO1Wpnxp"};